<script>
import { mapActions } from 'vuex';
import { useAlert } from 'dashboard/composables';

export default {
  name: "StatusDropdown",
  props: {
    status: {
      type: String,
      required: true
    },
    appointmentId: {
      type: String,
      required: true,
    },
  },  
  data() {
    return {
      isStatusDropdownOpen: false,
      statusOptions: ['requested', 'confirmed', 'cancelled', 'rescheduled'],
      statusIconMap: {
        cancelled: 'dismiss-circle',
        confirmed: 'checkmark-circle',
        rescheduled: 'arrow-sync',
        upcoming: 'checkmark',
        requested: 'clock',
        archive: 'dismiss-circle',
      },
    };
  },
  computed: {
    statusColorClass() {
      return {
        'bg-red-100 text-red-800':
          this.status === 'cancelled' || this.status === 'archive',
        'bg-green-100 text-green-800': this.status === 'confirmed',
        'bg-woot-100 text-woot-800': this.status === 'rescheduled',
        'bg-teal-100 text-teal-800': this.status === 'upcoming',
        'bg-orange-100 text-orange-800': this.status === 'requested',
      };
    },
  },
  methods: {
    ...mapActions('appointments', ['updateAppointmentStatus', 'fetchFilteredAppointments', 'updateFilters']),
    toggleDropdown() {
      this.isStatusDropdownOpen = !this.isStatusDropdownOpen;
    },
    selectStatus(option) {
      this.status = option;
      this.isStatusDropdownOpen = false;
    },
    handleClickOutside(e) {
      if (this.$refs.dropdownRef && !this.$refs.dropdownRef.contains(e.target)) {
        this.isStatusDropdownOpen = false;
      }
    },
    async handleUpdate(status){
      try{
        await this.updateAppointmentStatus({
          appointmentId: this.appointmentId,
          status: status
        });
        useAlert("Status updated successfully");
        this.isStatusDropdownOpen = false;
        await this.updateFilters({status: status});
      }catch(err){
        console.error(err);
        useAlert(err);
      }
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
    this.selectedStatus = this.status;
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
};
</script>

<template>
  <div
    class="px-2 py-0.5 rounded-full text-xs font-medium transition-colors relative inline-flex items-center"
    :class="statusColorClass"
    ref="dropdownRef"
    data-testid="status_dropdown"
  >    
    <fluent-icon
      :icon="statusIconMap[status] || 'clock'"
      size="12"
      class="inline-block mr-1 flex-shrink-0"
    />
    {{ status }}

    <button data-testid="status_dropdown_toggle" @click="toggleDropdown" class="ml-1 p-0">
      <fluent-icon icon="chevron-down" size="12"/>
    </button>

    <div
      v-if="isStatusDropdownOpen"
      class="absolute top-full left-0 mt-1 z-50 bg-white dark:bg-gray-800 rounded shadow-md border w-36"
    >
      <button
        v-for="option in statusOptions"
        :key="option"
        data-testid="status_dropdown_option"
        :data-status="option"
        @click="handleUpdate(option)"
        class="block w-full text-left px-3 py-1 text-sm hover:bg-gray-100 dark:hover:bg-gray-700"
      >
        {{ option }}
      </button>
    </div>
  </div>
</template>
